import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/flickr': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM144.5 319c35.1 0 63.5-28.4 63.5-63.5s-28.4-63.5-63.5-63.5-63.5 28.4-63.5 63.5 28.4 63.5 63.5 63.5zM303.5 319c35.1 0 63.5-28.4 63.5-63.5s-28.4-63.5-63.5-63.5-63.5 28.4-63.5 63.5 28.4 63.5 63.5 63.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/flickr.js
// module id = 828
// module chunks = 0